import abacus from '../images/abacus-hero.jpg';
import yoga from '../images/yoga-meditation.jpg';
import bhagavadGita from '../images/bhagvad-gita.jpg';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-orb hero-orb-one"></div>
      <div className="hero-orb hero-orb-two"></div>
      <div className="hero-content">
        <div className="hero-copy">
          <span className="eyebrow eyebrow-light">Learn • Grow • Thrive</span>
          <h1>Learning that builds <em>bright minds</em> and strong values.</h1>
          <p>
            Live, mentor-led learning in Abacus, Vedic Maths, Yoga, Bhagavad
            Gita lessons and whole-brain development—designed for every child.
          </p>
          <div className="hero-buttons">
            <a
              href="https://wa.me/919242912480?text=Hi%20I'm%20interested%20in%20a%20free%20trial!"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-accent"
            >
              Start a free trial <span aria-hidden="true">→</span>
            </a>
            <a href="#courses" className="btn btn-ghost">Explore courses</a>
          </div>
          <div className="hero-proof" aria-label="Program highlights">
            <div><strong>23+</strong><span>Years of expertise</span></div>
            <div><strong>8,000+</strong><span>Students trained</span></div>
            <div><strong>Live</strong><span>Online classes</span></div>
          </div>
        </div>

        <div className="hero-visual" aria-label="Featured learning programs">
          <div className="hero-image-main">
            <img src={abacus} alt="Student learning with an abacus" />
            <span className="image-label">Mind maths</span>
          </div>
          <div className="hero-image-small hero-image-yoga">
            <img src={yoga} alt="Yoga learning program" />
          </div>
          <div className="hero-image-small hero-image-gita">
            <img src={bhagavadGita} alt="Bhagavad Gita learning program" />
          </div>
          <div className="hero-note">
            <span aria-hidden="true">✦</span>
            <p><strong>Holistic education</strong> for mind, body and character</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
